import { CustomLink, Body, styled } from '@teko/ds-desktop';
import React from 'react';
import { getTrackingData } from '@teko/tracking';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const TopbarButton = (_a) => {
  var _b = _a, {
    children,
    icon,
    href,
    tracking,
    color
  } = _b, rest = __objRest(_b, [
    "children",
    "icon",
    "href",
    "tracking",
    "color"
  ]);
  return /* @__PURE__ */ React.createElement(CustomLink, {
    href
  }, /* @__PURE__ */ React.createElement(Button, __spreadValues(__spreadValues({}, tracking && getTrackingData(tracking)), rest), icon && /* @__PURE__ */ React.createElement(React.Fragment, null, icon, /* @__PURE__ */ React.createElement(Spacer, null)), /* @__PURE__ */ React.createElement(Body, {
    level: 1,
    color: color || "white"
  }, children)));
};
const Spacer = styled.span`
  width: 0.5rem;
`;
const Button = styled.button`
  padding: 0rem 1.25rem;
  height: 100%;
  background-color: transparent;
  display: flex;
  justify-content: center;
  align-items: center;
  outline: none;
  border: none;
  height: 42px;
  &:focus {
    outline: none;
  }
`;

export { TopbarButton };
